// extracted by mini-css-extract-plugin
export default {"About":"About_About__RLtiH","AboutText":"About_AboutText__jWIXl","CardContainer":"About_CardContainer__zoq9k","Card":"About_Card__MBO9B"};